export const nowParis = [
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/ccc48c1d113623eacee3066d0eccf6fdde4940c34a6516d65ee59d03.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Rooms for rent in 4-bedroom apartment in Créteil, Paris",
    rent: "430 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/405698",
    id: "paris1",
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/5fdc470539f1ae247e9f36ee63ca621967ddc39dc6e51fe1c8cb43df.jpg",
    type: "Room",
    available: "From 2 May",
    title: "Room for rent in 3-bedroom apartment in Mantes-La-Ville",
    rent: "500 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/655552",
    id: "paris2",
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/5faebf9a8ff4035d4461897eca0380f3f256a098c4de5f2a4a97b112.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room for rent in lovely 5-bedroom house, Noisy-Le-Grand",
    rent: "500 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/409706",
    id: "paris3",
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/bdbf0616dbf4cc15613ed131c4fe71aa067c16fa7d4b417e21c75d0e.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room for rent in lovely 5-bedroom house, Noisy-Le-Grand",
    rent: "500 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/409707",
    id: "paris4",
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/33b111c5c49c042731f8c46e604e933282e0d19558fda818b7d05764.jpg",
    type: "Room",
    available: "From 1 August",
    title: "Room for rent in lovely 5-bedroom house, Noisy-Le-Grand",
    rent: "550 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/409705",
    id: "paris5",
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/9233682cf39bf3297bb6d88f33ff289660aff5fca913af953bcc208e.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room for rent in lovely 5-bedroom house, Noisy-Le-Grand",
    rent: "550 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/409708",
    id: "paris6",
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/a1c0f6b80e6b49799beb8aa683b00e2e47586afacc4522e6bffe11c4.jpg",
    type: "Room",
    available: "From 1 November",
    title: "Room for rent in stylish 3-bedroom apartment",
    rent: "550 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/409086",
    id: "paris7",
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/451115222dac6be9d7484cd11c263d26e3267bff2e161437e93f2880.jpg",
    type: "Room",
    available: "From 1 November",
    title: "Room for rent in stylish 3-bedroom apartment",
    rent: "550 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/409087",
    id: "paris8",
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/de988a3ecfd5e9a90d27941dc5e755ef5103c121c6a64b9168101a57.jpg",
    type: "Room",
    available: "From 27 December",
    title: "Double room for rent, 3-bedroom apartment,Saint-Denis, Paris",
    rent: "570 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/376056",
    id: "paris9",
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/0e7624db3352523c3c31e04cbe2d0751776e0323f6db30f547e0f4c2.jpg",
    type: "Studio",
    available: "From 28 August",
    title: "Studio apartment for rent in Neuilly-sur-Seine, Paris",
    rent: "590 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/364617",
    id: "paris10",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 May",
    title: "Room for rent in 3-bedroom apartment in Mantes-La-Ville",
    rent: "600 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/655550",
    id: "paris11",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 6 August",
    title: "Furnished studio apartment for rent in Boulogne, Paris",
    rent: "600 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/125621",
    id: "paris12",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 17 December",
    title: "Furnished room in 4-bedroom house, Saint-Denis, Paris",
    rent: "600 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/220517",
    id: "paris13",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 17 December",
    title: "Cosy room in 4-bedroom house, Saint-Denis, Paris",
    rent: "600 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/220518",
    id: "paris14",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 17 December",
    title: "Bright room in 4-bedroom house, Saint-Denis, Paris",
    rent: "600 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/166833",
    id: "paris15",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 May",
    title: "Welcoming room in apartment in Vanves, Paris",
    rent: "620 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/603804",
    id: "paris16",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 May",
    title: "Welcoming room in apartment in Vanves, Paris",
    rent: "620 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/603805",
    id: "paris17",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 September",
    title: "Cozy studio for rent in the 16th arrondissement, Paris",
    rent: "650 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/224714",
    id: "paris18",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 May",
    title: "Comfortable room in apartment in Vanves, Paris",
    rent: "670 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/100269",
    id: "paris19",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 17 July",
    title: "Room for rent in 6-bedroom house in Sevran, Paris",
    rent: "670 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/403811",
    id: "paris20",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 28 October",
    title: "Inviting room in apartment in Vanves, Paris",
    rent: "670 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/115798",
    id: "paris21",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 14 August",
    title: "Cozy apartment for rent in Buttes-Montmartre, Paris",
    rent: "675 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/120669",
    id: "paris22",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 5 May",
    title: "Rooms for rent in 6-bedroom apartment in Rosny-Sous-Bois",
    rent: "680 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/668300",
    id: "paris23",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 5 May",
    title: "Rooms for rent in 6-bedroom apartment in Rosny-Sous-Bois",
    rent: "680 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/668299",
    id: "paris24",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 5 May",
    title: "Rooms for rent in 6-bedroom apartment in Rosny-Sous-Bois",
    rent: "680 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/668298",
    id: "paris25",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 5 May",
    title: "Rooms for rent in 6-bedroom apartment in Rosny-Sous-Bois",
    rent: "680 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/668295",
    id: "paris26",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 5 May",
    title: "Rooms for rent in 6-bedroom apartment in Rosny-Sous-Bois",
    rent: "680 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/668296",
    id: "paris27",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 August",
    title: "Studio apartment for rent in 15th arrondissement, Paris",
    rent: "680 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/125906",
    id: "paris28",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 September",
    title: "Studio apartment for rent in the 18th arrondissement, Paris",
    rent: "680 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/137295",
    id: "paris29",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 2 May",
    title: "Cosy studio apartment for rent in Asniéres-sur-Seine, Paris",
    rent: "690 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/148141",
    id: "paris30",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 19 June",
    title: "Studio apartment for rent in 17th arrondissement, Paris",
    rent: "690 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/204866",
    id: "paris31",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 6 September",
    title: "Relaxing room in apartment in Vanves, Paris",
    rent: "690 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/100470",
    id: "paris32",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 October",
    title: "Studio apartment for rent in Asnieres sur Seine, Paris",
    rent: "690 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/125550",
    id: "paris33",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 26 October",
    title: "Decorated room in apartment in Vanves, Paris",
    rent: "690 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/100270",
    id: "paris34",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 June",
    title: "Room in 7-bedroom apartment in Bezons, Paris",
    rent: "695 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/355570",
    id: "paris35",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 May",
    title: "Sunny room for rent in Puteaux, Paris",
    rent: "700 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/232423",
    id: "paris36",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 17 August",
    title: "Chic studio apartment for rent in Passy, Paris",
    rent: "700 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/117481",
    id: "paris37",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 May",
    title: "Furnished room in apartment in Vanves, Paris",
    rent: "720 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/115796",
    id: "paris38",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 May",
    title: "Welcoming room in apartment in Vanves, Paris",
    rent: "720 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/115797",
    id: "paris39",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 3 September",
    title: "Modern studio apartment for rent in Opéra, Paris 9th",
    rent: "730 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/115287",
    id: "paris40",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 26 October",
    title: "Welcoming room in apartment in Vanves, Paris",
    rent: "740 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/115795",
    id: "paris41",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 5 May",
    title: "Rooms for rent in 6-bedroom apartment in Rosny-Sous-Bois",
    rent: "750 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/668297",
    id: "paris42",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 2 August",
    title: "Studio apartment for rent in 18Ème Arrondissement , Paris",
    rent: "750 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/453777",
    id: "paris43",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 September",
    title: "Studio apartment for rent in 15Ème Arrondissement, Paris",
    rent: "750 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/607300",
    id: "paris44",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 October",
    title: "Studio apartment for rent in Batignolles-Monceau, Paris",
    rent: "750 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/117503",
    id: "paris45",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 June",
    title: "Room in 7-bedroom apartment in Bezons, Paris",
    rent: "765 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/355578",
    id: "paris46",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 June",
    title: "Cute studio apartment for rent in 15h arrondissement, Paris",
    rent: "780 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/221408",
    id: "paris47",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 10 August",
    title: "Studio apartment for rent in 14th arrondissement, Paris",
    rent: "780 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/133666",
    id: "paris48",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 2 September",
    title: "Studio apartment for rent in Aubervilliers, Paris",
    rent: "780 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/601249",
    id: "paris49",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 2 May",
    title: "Studio apartment for rent in 17Ème Arrondissement , Paris",
    rent: "790 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/440705",
    id: "paris50",
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 24 December",
    title: "Room for rent in 5-bedroom apartment in Bagneux, Paris",
    rent: "799 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:rooms/447894",
    id: "paris51",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 22 August",
    title: "Colorful studio in Paris city centre, close to Louvre",
    rent: "800 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/109858",
    id: "paris52",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 5 September",
    title: "Modern studio apartment for rent in Neuilly-Sur-Seine, Paris",
    rent: "800 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/608331",
    id: "paris53",
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 14 October",
    title: "Studio apartment for rent in Paris 17",
    rent: "800 €",
    permonth: "/month",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/paris/for-rent:studios/214302",
    id: "paris54",
  },
];